import {MatchmakingMatchTypes} from '@colonist/game-base-types'
import {audioManager, AudioType} from '../../../shared/scripts/Sound'
import {uiManager} from '../EntryHomepage'
import {SocketLobbySend} from '../../../shared/scripts/socket/SocketLobbySend'
import {ViewPopupRankedGameDescription} from '../../../shared/scripts/ui_popup/ViewPopupRankedGameDescription.ts'
import {KeyBindController, ShortcutLocation} from '../../../shared/scripts/KeyBindController'
import {setElementInnerHTML, createLinkIn, setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import {createGloballyExclusiveHandler, navigateToPage, throttleUserAction} from '../../../shared/scripts/ui_utils/ClientUtils'
import {getMatchTypeEligibilityAndCreatePopup, getMatchTypeDescription, userCanAttemptAccessToRankedCitiesAndKnights} from '../../../shared/scripts/matchmaking/MatchmakingUtilsClient'
import {ClientUserState} from '../../../shared/scripts/ClientUserState'
import {CA} from '../../../shared/scripts/analytics/Analytics'
import {AnalyticEventCategory, AnalyticEventType, AnalyticEventValue} from '../../../../shared/entity_datas/EntityDatas'
import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes.ts'
import {TranslationObject} from '@colonist/i18n'
import {FindGameRankedState} from '../../../../shared/ranked/ranked_user_state_data/FindGameRankedState'
import {UIAjaxWrapper} from '../../../shared/scripts/network/UIAjaxWrapper.ts'
import {UIAPIEndpoints} from '../../../shared/scripts/network/UIAPIEndpoints.ts'

type SelectedGameMode = 'beginner_mode' | 'easy_bots' | 'medium_bots' | 'hard_bots' | MatchmakingMatchTypes.UnrankedClassic4P | MatchmakingMatchTypes.UnrankedClassic1v1 | MatchmakingMatchTypes.RankedCitiesAndKnights4P | MatchmakingMatchTypes.RankedClassic4P | MatchmakingMatchTypes.RankedClassic1v1

export class UIMatchmakingSelectMatchPopupView {
    private readonly container: HTMLDivElement
    private readonly content: HTMLDivElement
    private readonly optionBot: HTMLDivElement
    private readonly optionUnranked4Player: HTMLDivElement
    private readonly optionRanked4Player: HTMLDivElement
    private readonly optionUnranked1v1: HTMLDivElement
    private readonly optionRanked1v1: HTMLDivElement
    private readonly optionRankedCitiesAndKnights: HTMLDivElement
    private readonly optionBeginnerMode: HTMLDivElement
    private readonly optionEasyBots: HTMLDivElement
    private readonly optionMediumBots: HTMLDivElement
    private readonly optionHardBots: HTMLDivElement
    private readonly popupTitle: HTMLParagraphElement
    readonly rankedStateRankedBase: HTMLParagraphElement
    readonly rankedStateRanked1v1: HTMLParagraphElement
    readonly rankedStateCitiesAndKnights: HTMLParagraphElement

    private readonly rankedGameDescriptionBtn: HTMLDivElement
    private readonly closeBtn: HTMLImageElement

    private readonly rankedClassicIcon: HTMLImageElement
    private readonly ranked1v1Icon: HTMLImageElement
    private readonly rankedCitiesAndKnightsIcon: HTMLImageElement

    private readonly rankedClassicLockIcon: HTMLImageElement
    private readonly ranked1v1LockIcon: HTMLImageElement
    private readonly rankedCitiesAndKnightsLockIcon: HTMLImageElement

    private readonly searchButton: HTMLAnchorElement
    private readonly citiesAndKnightsSubscribeButton: HTMLAnchorElement

    private selectedGameMode: SelectedGameMode | undefined

    constructor() {
        this.container = document.getElementById('matchmaking-selectmatch-popup') as HTMLDivElement
        this.popupTitle = document.getElementById('matchmaking-selectmatch-popup-title') as HTMLParagraphElement
        this.content = document.getElementById('matchmaking-selectmatch-popup-content') as HTMLDivElement
        this.optionBot = document.getElementById('matchmaking_popup_item_bot') as HTMLDivElement
        this.optionBeginnerMode = document.getElementById('matchmaking_popup_item_beginnerMode') as HTMLDivElement
        this.optionUnranked4Player = document.getElementById('matchmaking_popup_item_classic') as HTMLDivElement
        this.optionRanked4Player = document.getElementById('matchmaking_popup_item_ranked_classic') as HTMLDivElement
        this.optionRankedCitiesAndKnights = document.getElementById('matchmaking_popup_item_ranked_cities_and_knights') as HTMLDivElement
        this.optionUnranked1v1 = document.getElementById('matchmaking_popup_item_1v1') as HTMLDivElement
        this.optionRanked1v1 = document.getElementById('matchmaking_popup_item_ranked_1v1') as HTMLDivElement
        this.optionEasyBots = document.getElementById('matchmaking_popup_item_easy_bots') as HTMLDivElement
        this.optionMediumBots = document.getElementById('matchmaking_popup_item_medium_bots') as HTMLDivElement
        this.optionHardBots = document.getElementById('matchmaking_popup_item_hard_bots') as HTMLDivElement
        this.rankedStateRanked1v1 = document.getElementById('matchmaking_popup_item_ranked_1v1_rankedstate') as HTMLParagraphElement
        this.rankedStateRankedBase = document.getElementById('matchmaking_popup_item_ranked_classic_rankedstate') as HTMLParagraphElement
        this.rankedStateCitiesAndKnights = document.getElementById('matchmaking_popup_item_ranked_cities_and_knights_rankedstate') as HTMLParagraphElement

        this.rankedGameDescriptionBtn = document.getElementById('matchmaking_popup_ranked_game_description_btn') as HTMLDivElement
        this.closeBtn = document.getElementById('matchmaking_popup_close_btn') as HTMLImageElement

        this.rankedClassicIcon = this.optionRanked4Player.querySelector('.matchmaking_option_item_body_image_icon') as HTMLImageElement
        this.ranked1v1Icon = this.optionRanked1v1.querySelector('.matchmaking_option_item_body_image_icon') as HTMLImageElement
        this.rankedCitiesAndKnightsIcon = this.optionRankedCitiesAndKnights.querySelector('.matchmaking_option_item_body_image_icon') as HTMLImageElement

        this.rankedClassicLockIcon = this.optionRanked4Player.querySelector('.matchmaking_option_item_body_image_lock') as HTMLImageElement
        this.ranked1v1LockIcon = this.optionRanked1v1.querySelector('.matchmaking_option_item_body_image_lock') as HTMLImageElement
        this.rankedCitiesAndKnightsLockIcon = this.optionRankedCitiesAndKnights.querySelector('.matchmaking_option_item_body_image_lock') as HTMLImageElement

        this.searchButton = document.querySelector('.matchmaking_popup_search_button') as HTMLAnchorElement
        this.citiesAndKnightsSubscribeButton = document.getElementById('matchmaking_popup_item_ranked_cities_and_knights_cta') as HTMLAnchorElement

        setElementOnClick(this.optionBot, throttleUserAction(() => {
            audioManager.play(AudioType.Click)
            this.showAllBotOptions()
        }))

        setElementOnClick(this.optionEasyBots, () => {
            audioManager.play(AudioType.Click)
            this.selectGameMode('easy_bots', this.optionEasyBots)
        })

        setElementOnClick(this.optionMediumBots, () => {
            audioManager.play(AudioType.Click)
            this.selectGameMode('medium_bots', this.optionMediumBots)
        })

        setElementOnClick(this.optionHardBots, () => {
            audioManager.play(AudioType.Click)
            this.selectGameMode('hard_bots', this.optionHardBots)
        })

        setElementOnClick(this.optionBeginnerMode, () => {
            audioManager.play(AudioType.Click)
            this.selectGameMode('beginner_mode', this.optionBeginnerMode)
        })

        setElementOnClick(this.optionUnranked4Player, () => {
            audioManager.play(AudioType.Click)
            this.selectGameMode(MatchmakingMatchTypes.UnrankedClassic4P, this.optionUnranked4Player)
        })

        setElementOnClick(this.optionRanked4Player, () => {
            audioManager.play(AudioType.Click)
            this.selectGameMode(MatchmakingMatchTypes.RankedClassic4P, this.optionRanked4Player)
        })

        setElementOnClick(this.optionUnranked1v1, () => {
            audioManager.play(AudioType.Click)
            this.selectGameMode(MatchmakingMatchTypes.UnrankedClassic1v1, this.optionUnranked1v1)
        })

        setElementOnClick(this.optionRankedCitiesAndKnights, () => {
            audioManager.play(AudioType.Click)
            this.selectGameMode(MatchmakingMatchTypes.RankedCitiesAndKnights4P, this.optionRankedCitiesAndKnights)
        })

        setElementOnClick(this.optionRanked1v1, () => {
            audioManager.play(AudioType.Click)
            this.selectGameMode(MatchmakingMatchTypes.RankedClassic1v1, this.optionRanked1v1)
        })

        setElementOnClick(this.searchButton, createGloballyExclusiveHandler(async() => {
            if(this.selectedGameMode == undefined) return

            const {isEligible, createPopup} = getMatchTypeEligibilityAndCreatePopup(this.selectedGameMode as MatchmakingMatchTypes)
            if(!isEligible) {
                createPopup?.()
                return
            }

            audioManager.play(AudioType.Click)
            await this.executeSelectedGameMode()
        }))

        setElementOnClick(this.citiesAndKnightsSubscribeButton, () => {
            this.hide()
            UIMatchmakingSelectMatchPopupView.sendSubscribeCTAAnalyticEvent()
            navigateToPage('/store#membership', true)
        }, false, true)

        setElementOnClick(this.rankedGameDescriptionBtn, (event: MouseEvent) => {
            audioManager.play(AudioType.Click)
            UIMatchmakingSelectMatchPopupView.showRankedGameDescription(event)
        })

        setElementOnClick(this.closeBtn, () => {
            audioManager.play(AudioType.Click)
            this.hide()
        })

        this.setCancel()
        this.setKeyBind()
    }

    private static showRankedGameDescription(mouseEvent: MouseEvent) {
        mouseEvent.stopPropagation()
        mouseEvent.preventDefault()
        new ViewPopupRankedGameDescription()
    }

    private setCancel() {
        window.addEventListener('click', createGloballyExclusiveHandler((event: PointerEvent) => {
            if(event.target == this.container) {
                this.hide()
            }
        }))
    }

    private setKeyBind() {
        KeyBindController.bindKey('Escape', createGloballyExclusiveHandler<void>(() => this.hide()), () => this.isVisible(), ShortcutLocation.InLobby)
    }

    private isVisible(): boolean {
        return this.container.style.display == 'block'
    }

    removeOptionRanked1v1() {
        this.optionRanked1v1.style.display = 'none'
    }

    removeOptionRankedBase() {
        this.optionRanked4Player.style.display = 'none'
    }

    removeOptionRankedCitiesAndKnights() {
        this.optionRankedCitiesAndKnights.style.display = 'none'
    }

    private removeOptionUnranked4Player() {
        this.optionUnranked4Player.style.display = 'none'
    }

    private removeOptionUnranked1Player() {
        this.optionUnranked1v1.style.display = 'none'
    }

    private showOptionRanked1v1() {
        this.optionRanked1v1.style.display = 'flex'
    }

    private showOptionBot() {
        this.optionBot.style.display = 'flex'
    }

    private showOptionBeginnerMode() {
        this.optionBeginnerMode.style.display = 'flex'
    }

    private showOptionRankedBase() {
        this.optionRanked4Player.style.display = 'flex'
    }

    private showOptionRankedCitiesAndKnights() {
        this.optionRankedCitiesAndKnights.style.display = 'flex'
    }

    private showOptionUnranked4Player() {
        this.optionUnranked4Player.style.display = 'flex'
    }

    private showOptionUnranked1Player() {
        this.optionUnranked1v1.style.display = 'flex'
    }

    private removeOptionBeginnerMode() {
        this.optionBeginnerMode.style.display = 'none'
    }

    private removeOptionBot() {
        this.optionBot.style.display = 'none'
    }

    private showOptionEasyBots() {
        this.optionEasyBots.style.display = 'flex'
    }

    private showOptionMediumBots() {
        this.optionMediumBots.style.display = 'flex'
    }

    private showOptionHardBots() {
        this.optionHardBots.style.display = 'flex'
    }

    private removeOptionEasyBots() {
        this.optionEasyBots.style.display = 'none'
    }

    private removeOptionMediumBots() {
        this.optionMediumBots.style.display = 'none'
    }

    private removeOptionHardBots() {
        this.optionHardBots.style.display = 'none'
    }

    hideRankedOptions() {
        this.hideOptions()
        this.showOptionUnranked1Player()
        this.showOptionUnranked4Player()
        this.hideInfoIcon()
    }

    showRankedOptions() {
        this.hideOptions()
        this.showOptionUnranked1Player()
        this.showOptionUnranked4Player()
        this.showOptionRanked1v1()
        this.showOptionRankedBase()
        this.showOptionRankedCitiesAndKnights()
        this.showInfoIcon()
    }

    private hideOptions() {
        this.clearSelection()
        this.removeOptionRanked1v1()
        this.removeOptionRankedBase()
        this.removeOptionRankedCitiesAndKnights()
        this.removeOptionUnranked4Player()
        this.removeOptionUnranked1Player()
        this.removeOptionBot()
        this.removeOptionBeginnerMode()
        this.removeOptionEasyBots()
        this.removeOptionMediumBots()
        this.removeOptionHardBots()
    }

    showSinglePlayerOptions() {
        setElementInnerHTML(this.popupTitle, {key: 'strings:homePage.ctas.singlePlayer'})
        this.hideOptions()
        this.showOptionBeginnerMode()
        this.showOptionBot()
        this.hideInfoIcon()
    }

    showAllBotOptions() {
        setElementInnerHTML(this.popupTitle, {key: 'strings:homePage.ctas.playVsBots'})
        this.hideOptions()
        this.showOptionEasyBots()
        this.showOptionMediumBots()
        this.showOptionHardBots()
        this.hideInfoIcon()
    }

    setMatchmakingOptionsHeader() {
        setElementInnerHTML(this.popupTitle, {key: 'strings:homePage.matchmakingPopup.selectGameType'})
    }

    hide() {
        this.container.style.display = 'none'
        this.clearSelection()
        this.selectedGameMode = undefined
        this.searchButton.classList.add('disabled')
    }

    show() {
        this.container.style.display = 'block'
    }

    private static sendSubscribeCTAAnalyticEvent() {
        const eventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: AnalyticEventCategory.ABTestClickAnalytics,
            floatValue: AnalyticEventValue.MatchmakingPopupRankedCitiesAndKnightsSubscribeCTA,
        }
        void CA.sendAnalyticEvent(eventData)
    }

    async setRankedEligibilityAndDescription() {
        const displayError = false
        const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiFindGameState(), undefined, undefined, displayError)
        if(response == undefined) return
        const findGameRankedStates = response.json as FindGameRankedState[]

        const {isEligible: isEligibleForRankedClassic, createPopup: popupClassic} = getMatchTypeEligibilityAndCreatePopup(MatchmakingMatchTypes.RankedClassic4P)
        const {isEligible: isEligibleForRanked1v1, createPopup: popup1v1} = getMatchTypeEligibilityAndCreatePopup(MatchmakingMatchTypes.RankedClassic1v1)
        const {isEligible: isEligibleForRankedCitiesAndKnights, createPopup: popupCnK} = getMatchTypeEligibilityAndCreatePopup(MatchmakingMatchTypes.RankedCitiesAndKnights4P)

        this.setRankedClassicView(isEligibleForRankedClassic)
        this.setRanked1v1View(isEligibleForRanked1v1)
        this.setRankedCitiesAndKnightsView(isEligibleForRankedCitiesAndKnights)

        const ranked4PDescription = getMatchTypeDescription(MatchmakingMatchTypes.RankedClassic4P, findGameRankedStates)
        const ranked1v1Description = getMatchTypeDescription(MatchmakingMatchTypes.RankedClassic1v1, findGameRankedStates)
        const rankedCnKDescription = getMatchTypeDescription(MatchmakingMatchTypes.RankedCitiesAndKnights4P, findGameRankedStates)

        this.setRankedCardDescription(this.rankedStateRankedBase, isEligibleForRankedClassic, popupClassic, ranked4PDescription)
        this.setRankedCardDescription(this.rankedStateRanked1v1, isEligibleForRanked1v1, popup1v1, ranked1v1Description)
        this.setRankedCardDescription(this.rankedStateCitiesAndKnights, isEligibleForRankedCitiesAndKnights, popupCnK, rankedCnKDescription)
    }

    private setRankedClassicView(isEligible: boolean) {
        this.rankedClassicLockIcon.classList.toggle('hidden', isEligible)
        this.rankedClassicIcon.classList.toggle('disabled', !isEligible)
    }

    private setRanked1v1View(isEligible: boolean) {
        this.ranked1v1LockIcon.classList.toggle('hidden', isEligible)
        this.ranked1v1Icon.classList.toggle('disabled', !isEligible)
    }

    private setRankedCitiesAndKnightsView(isEligible: boolean) {
        this.rankedCitiesAndKnightsLockIcon.classList.toggle('hidden', isEligible)
        this.rankedCitiesAndKnightsIcon.classList.toggle('disabled', !isEligible)

        const shouldShowMembershipCTA = !userCanAttemptAccessToRankedCitiesAndKnights(ClientUserState.userState?.items, ClientUserState.userState?.ckTotalGameCount, ClientUserState.abTests, ClientUserState.userState?.ckFreeGameUntil, ClientUserState.userState?.ckNextRerollAt)
        this.rankedStateCitiesAndKnights.classList.toggle('hidden', shouldShowMembershipCTA)
        this.citiesAndKnightsSubscribeButton.classList.toggle('hidden', !shouldShowMembershipCTA)
    }

    // eslint-disable-next-line class-methods-use-this
    private setRankedCardDescription(element: HTMLParagraphElement, isEligible: boolean, createPopup: (() => void) | undefined, description: TranslationObject) {
        if(!isEligible && createPopup != undefined) {
            setElementInnerHTML(element, {key: 'strings:colonistCommon.utils.emptyString'})
            const link = createLinkIn(element, '', description, '')
            setElementOnClick(link, () => createPopup(), true, true)
            return
        }

        setElementInnerHTML(element, description)
    }

    private async executeSelectedGameMode() {
        switch(this.selectedGameMode) {
            case 'beginner_mode':
                await SocketLobbySend.continueCampaignMode()
                this.hide()
                break
            case 'easy_bots':
                await SocketLobbySend.clickedStartEasyBotGame()
                this.hide()
                break
            case 'medium_bots':
                await SocketLobbySend.clickedStartMediumBotGame()
                this.hide()
                break
            case 'hard_bots':
                await SocketLobbySend.clickedStartHardBotGame()
                this.hide()
                break
            case MatchmakingMatchTypes.UnrankedClassic4P:
                await ClientUserState.requireUser()
                uiManager.matchmakingController.sendFindGameMessageToServer(MatchmakingMatchTypes.UnrankedClassic4P)
                break
            case MatchmakingMatchTypes.UnrankedClassic1v1:
                await ClientUserState.requireUser()
                uiManager.matchmakingController.sendFindGameMessageToServer(MatchmakingMatchTypes.UnrankedClassic1v1)
                break
            case MatchmakingMatchTypes.RankedCitiesAndKnights4P:
                uiManager.matchmakingController.sendFindGameMessageToServer(MatchmakingMatchTypes.RankedCitiesAndKnights4P)
                break
            case MatchmakingMatchTypes.RankedClassic4P:
                uiManager.matchmakingController.sendFindGameMessageToServer(MatchmakingMatchTypes.RankedClassic4P)
                break
            case MatchmakingMatchTypes.RankedClassic1v1:
                uiManager.matchmakingController.sendFindGameMessageToServer(MatchmakingMatchTypes.RankedClassic1v1)
                break
            case undefined:
                break
        }
    }

    private selectGameMode(gameMode: SelectedGameMode, element: HTMLDivElement) {
        this.clearSelection()

        element.classList.add('selected')
        this.selectedGameMode = gameMode

        const {isEligible} = getMatchTypeEligibilityAndCreatePopup(gameMode as MatchmakingMatchTypes)
        this.searchButton.classList.toggle('disabled', !isEligible)
    }

    private clearSelection() {
        const allOptions = [
            this.optionBot, this.optionBeginnerMode, this.optionUnranked4Player,
            this.optionRanked4Player, this.optionRankedCitiesAndKnights,
            this.optionUnranked1v1, this.optionRanked1v1, this.optionEasyBots,
            this.optionMediumBots, this.optionHardBots,
        ]
        allOptions.forEach((option) => option.classList.remove('selected'))

        this.selectedGameMode = undefined
        this.searchButton.classList.add('disabled')
    }

    private hideInfoIcon() {
        this.rankedGameDescriptionBtn.classList.add('hidden')
    }

    private showInfoIcon() {
        this.rankedGameDescriptionBtn.classList.remove('hidden')
    }
}
